import { Injectable, Injector } from "@angular/core";
import { Constants } from "./common.const";
import { Router } from "@angular/router";
import { HttpHeaders } from "@angular/common/http";
import * as jwt_decode from "jwt-decode";
import { IfStmt } from "@angular/compiler";
import { BehaviorSubject, Observable } from "rxjs";
import { StreamService } from "./stream.service";

@Injectable()
export class CommonService extends Constants {
  public httpOptions = {};

  constructor(private injector: Injector, private streamService: StreamService) {
    super();
  }

  public get router(): Router {
    return this.injector.get(Router);
  }

  private loginStatus$ = new BehaviorSubject<String>(this.isAuthenticated() ? "loggedIn" : "loggedOut");
  public get loginStatusSub(): Observable<String> {
    return this.loginStatus$; 
  }

  getToken(endPoint: any) {
    let token = localStorage.getItem("token");
    let projectId = localStorage.getItem("_project")
  switch (endPoint) {
      case this.basic:
        this.httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "projectid":projectId
          })
        };
        if(token) {
          this.httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
             "Authorization": token,
             "projectid":projectId
            })
          };
        }
        break;
      case this.bearer:
        this.httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "projectid":projectId
          })
        };
        if(token) {
          this.httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
             "Authorization": token,
             "projectid":projectId
            })
          };
        }
        break;
      default:
        break;
    }
    return this.httpOptions;
  }
  getTokenForm(endPoint: any) {
    let token = localStorage.getItem("tokenForm");
    let projectId = localStorage.getItem("_project")
  switch (endPoint) {
      case this.basic:
        this.httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "projectid":projectId
          })
        };
        if(token) {
          this.httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
             "Authorization": token,
             "projectid":projectId
            })
          };
        }
        break;
      case this.bearer:
        this.httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "projectid":projectId
          })
        };
        if(token) {
          this.httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
             "Authorization": token,
             "projectid":projectId
            })
          };
        }
        break;
      default:
        break;
    }
    return this.httpOptions;
  }
  getPrjectToken(endPoint: any) {
    let projectId = localStorage.getItem("_project")
  switch (endPoint) {
      case this.basic:
        this.httpOptions = {
          headers: new HttpHeaders({
            "projectid":projectId
          })
        };
       
      case this.bearer:
        this.httpOptions = {
          headers: new HttpHeaders({
            "projectid":projectId
          })
        };

      default:
        break;
    }
    return this.httpOptions;
  }

  setStorage(key, value): any {
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
    if (key == "token") this.loginStatus$.next("loggedIn");
  }

  getStorage(key): any {
    const x = localStorage.getItem(key);
    try {
      const xx = JSON.parse(x);
      return xx;
    } catch (e) {
      return x;
    }
  }
  removeStorage(key): any {
    localStorage.removeItem(key);
  }

  getUser() {
    const token = this.getStorage("token");
    const userData = jwt_decode(token);
    return userData;
  }
  // getTokenRole() {
  //   const token = this.getStorage("token");
  //   const tokenRole = jwt_decode(token);
  //   return tokenRole;
  // }

  isAuthenticated() {
    if (localStorage.getItem("token") == null) {
      return false;
    } else {
      return true;
    }
  }


  logOut() {
    let projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
    
    document.documentElement.style.setProperty('--theme_primary', projectDetail['primaryThemeColor']);
    document.documentElement.style.setProperty('--theme_secondary', projectDetail['secondaryThemeColor']);
  // this._document.getElementById('appFavicon').setAttribute('href',this.projectDetail['icon']);


  localStorage.removeItem('userData');
  localStorage.removeItem('token');
  this.streamService.setInitialChatConfig(true);
  this.router.navigate(["signin"]);
  this.loginStatus$.next("loggedOut");
  
  }
}
